enum ASSIGNED_STATUS {
  ALL = 0,
  ASSIGNED = 1,
  UNASSIGNED = 2,
}

export default ASSIGNED_STATUS;